import { call, put, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import {
  REQUEST, fetchSuccess, fetchFailure,
  RERUN_REQUEST, rerunSuccess, rerunFailure,
} from '../../actions/discovery/studioForecast';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// Transient failures (network drop, gateway 5xx while the model server
// cold-starts) are retried quietly instead of surfacing an error toast —
// the champion can take a minute or two to come up after being idle.
const RETRY_DELAYS_MS = [5000, 10000, 20000];

const isTransient = (error) => {
  const status = error?.response?.status;
  if (status == null) return true; // network error / timeout
  return status >= 500 || status === 408 || status === 429;
};

function* operation(action) {
  const goalId = action?.payload?.goalId;
  for (let attempt = 0; ; attempt += 1) {
    try {
      const response = yield call(
        axios.get,
        `${config.API_URL}/goals/${goalId}/forecast`,
        { headers: getLocalUser() },
      );
      yield put(fetchSuccess(response?.data?.data));
      return;
    } catch (error) {
      if (isTransient(error) && attempt < RETRY_DELAYS_MS.length) {
        yield delay(RETRY_DELAYS_MS[attempt]);
        continue;
      }
      yield put(Error(error));
      yield put(fetchFailure(extractErrorMessage(error)));
      return;
    }
  }
}

function* rerunOperation(action) {
  try {
    const goalId = action?.payload?.goalId;
    const response = yield call(
      axios.post,
      `${config.API_URL}/goals/${goalId}/forecast/rerun`,
      {},
      { headers: getLocalUser() },
    );
    yield put(rerunSuccess(response?.data?.data));
  } catch (error) {
    yield put(Error(error));
    yield put(rerunFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
  yield takeLatest(RERUN_REQUEST, rerunOperation);
}
